<span
  *ngIf="condition && condition !== ''"
  class="tw-mb-1 tw-flex tw-items-start tw-gap-2 tw-rounded-lg tw-bg-tealgray-50 tw-px-3 tw-py-2 tw-text-xs tw-leading-4 tw-tracking-tight tw-text-dt-text-headings"
>
  <span class="accordion-list-item-bullet"></span>
  {{ condition }}
</span>
